import React, { useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

const MySwal = withReactContent(Swal);

const PdfViewerModal = ({ 
  show, 
  onHide, 
  title = 'Vista Previa del Documento', 
  url, 
  size = 'xl'
}) => {
  const [pdfLoading, setPdfLoading] = useState(false);

  const handleCloseModal = () => {
    setPdfLoading(false);
    onHide();
  };

  // Reset loading state when URL changes
  useEffect(() => {
    if (show && url) {
      setPdfLoading(true);
      // Simular un pequeño delay para mostrar el loading
      const timer = setTimeout(() => setPdfLoading(false), 500);
      return () => clearTimeout(timer);
    }
  }, [show, url]);

  return (
    <Modal 
      show={show} 
      onHide={handleCloseModal} 
      size={size}
      className="pdf-modal"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {pdfLoading ? (
          <div className="text-center py-5">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Cargando...</span>
            </div>
            <p className="mt-3">Cargando el documento...</p>
          </div>
        ) : (
          <div className="pdf-embed-container">
            <embed
              src={url}
              type="application/pdf"
              width="100%"
              height="600px"
              style={{ border: 'none' }}
            />
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-secondary" onClick={handleCloseModal}>
          Cerrar
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default PdfViewerModal;
